export default{
    cart:{
        cart_data:[],
        success:false,
        save_loader:false,
        submit_contact:true,
        error:[]
    }

}